import { render, staticRenderFns } from "./PdfStandardViewer.vue?vue&type=template&id=fc744c16&"
import script from "./PdfStandardViewer.vue?vue&type=script&lang=js&"
export * from "./PdfStandardViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfStandardViewer.vue?vue&type=style&index=0&id=fc744c16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports